module.exports = __webpack_public_path__ + "static/media/startThread.85fe753a.svg";